module.exports = __webpack_public_path__ + "img/album11_01.d2f1481e.jpg";